import {Directive, EventEmitter, HostListener, Input, Output, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';

@Directive({ selector: '[delegateClick]' })

export class DelegateClickDirective {

    @Input() delegatedTo: string = '';
    @Input() delegatedClick: string = '';

    @HostListener('click') onClick() {
        console.log('HASHDHASJDASHDASJKDJAS')
    }
}
    //@Output() delegateClick: EventEmitter<InnerClickEvent> = new EventEmitter<InnerClickEvent>();
/*
    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
console.log('onClick')
console.log(event)
console.log(this.delegatedTo)
console.log(this.delegatedClick)

      const target: HTMLElement = event.target as HTMLElement;
      // do nothing if the clicked item is the decorated element itself or delegated not set
      if (target === this.elementRef.nativeElement || !this.delegatedTo) {
        return;
      }
      event.preventDefault();
      this.handleClick(event.target as HTMLElement);

    }
    constructor(private elementRef: ElementRef) {}
*/
/*  
    handleClick(element: HTMLElement) {
console.log('handleClick')
console.log(element)

      if (element.matches(this.delegatedTo)) {
        this.delegateClick.next({ detail: element.dataset, target: element });
        return;
      }
      // also stop searching if we reach the container itself
      if (element === this.elementRef.nativeElement) {
        return;
      }
      this.handleClick(element.parentElement);

    }
  }
  
  export interface InnerClickEvent {
    target: HTMLElement;
    detail: DOMStringMap;
  }
*/